import { ConstructionSiteSubmissionColumns } from "@dune/types";
import { ColumnDef } from "@tanstack/react-table";
import { format } from "date-fns";
import { ConstructionSiteStatusBadge } from "../../../../component/constructionSites/ConstructionSiteStatusBadge";

export const getConstructionForContractorColumns =
	(): ColumnDef<ConstructionSiteSubmissionColumns>[] => [
		{
			accessorKey: "constructionSiteSubmission.constructionSite.id",
			header: "Ref",
			cell: ({ row }) => {
				const submission = row.original;
				const constructionSiteId =
					submission.constructionSiteSubmission?.constructionSite?.id;
				const ref = `CH-${constructionSiteId || "N/A"}`;

				return <span className="text-gray-900">{ref}</span>;
			},
		},
		{
			accessorKey: "constructionSiteSubmission.constructionSite.status",
			header: "Statut",
			cell: ({ row }) => {
				const submission = row.original;
				const status =
					submission.constructionSiteSubmission?.constructionSite?.status;
				const isSkipped =
					submission.constructionSiteSubmission?.constructionSite?.isSkipped;

				if (!status) return "-";

				return (
					<ConstructionSiteStatusBadge status={status} isSkipped={isSkipped} />
				);
			},
		},
		{
			accessorKey:
				"constructionSiteSubmission.constructionSite.constructionSiteDetails.cityHallStartDate",
			header: "DOC",
			cell: ({ row }) => {
				const submission = row.original;
				const cityHallStartDate =
					submission.constructionSiteSubmission?.constructionSite
						?.constructionSiteDetails?.cityHallStartDate;

				if (!cityHallStartDate) return "-";

				return format(new Date(cityHallStartDate), "yyyy") || "-";
			},
		},
		{
			accessorKey:
				"constructionSiteSubmission.constructionSite.constructionSiteDetails.totalAmountTTC",
			header: "Montant du marché",
			cell: ({ row }) => {
				const submission = row.original;
				const totalAmountTTC =
					submission.constructionSiteSubmission?.constructionSite
						?.constructionSiteDetails?.totalAmountTTC ||
					submission.constructionSiteSubmission?.constructionSite
						?.constructionSiteDetails?.totalAmountHT;

				if (!totalAmountTTC) return "-";

				return `${totalAmountTTC.toString()} €`;
			},
		},
		{
			accessorKey: "totalMissionsOrActivitiesOrMaterialTypes",
			header: "Activités réalisées",
			cell: ({ row }) => {
				const submission = row.original;
				const activities = submission.totalMissionsOrActivitiesOrMaterialTypes;

				if (!activities) return "-";

				if (Array.isArray(activities)) {
					return activities.join(", ");
				}

				return activities;
			},
		},
	];

export const constructionForContractorColumns =
	getConstructionForContractorColumns();
